import { useState, type ReactNode } from "react";
import { Alert, Button, Stack } from "@mui/joy";
import { useLogoutWithoutRouter } from "../hooks/useLogout";
import BootstrapShell from "./BootstrapShell";

/** Recovery must work without an admitted tenant or a query client. */
export default function AdmissionShell({ children }: { children?: ReactNode }) {
    // Admission's screens sit above a host's routers (the desktop's per-tab ones).
    const logout = useLogoutWithoutRouter();
    const [signingOut, setSigningOut] = useState(false);
    const [logoutFailed, setLogoutFailed] = useState(false);
    const signOut = async () => {
        setSigningOut(true);
        setLogoutFailed(false);
        try {
            await logout({ hardRedirect: true });
        } catch {
            setLogoutFailed(true);
        } finally {
            setSigningOut(false);
        }
    };
    return (
        <BootstrapShell
            actions={
                <Stack direction="row" spacing={1}>
                    <Button
                        // Leave the tenant basename even when its admission failed.
                        onClick={() => window.location.assign("/")}
                        variant="plain"
                        color="neutral"
                    >
                        Home
                    </Button>
                    <Button variant="plain" color="neutral" loading={signingOut} onClick={signOut}>
                        Sign out
                    </Button>
                </Stack>
            }
        >
            {logoutFailed && (
                <Alert color="warning">
                    Could not finish signing out. Try again or return Home.
                </Alert>
            )}
            {children}
        </BootstrapShell>
    );
}
